module.exports = __webpack_public_path__ + "img/score-10.9435b62a.png";